<script>
import { VDataTableHeader } from 'vuetify/lib'
import VDataTableHeaderMobile from 'vuetify/lib/components/VDataTable/VDataTableHeaderMobile'
import VDataTableHeaderDesktop from 'vuetify/lib/components/VDataTable/VDataTableHeaderDesktop'
import dedupeModelListeners from 'vuetify/lib/util/dedupeModelListeners'
import mergeData from 'vuetify/lib/util/mergeData'

import rebuildSlots from 'vuetify/lib/util/rebuildFunctionalSlots'
import EDataTableHeaderDesktop from './EDataTableHeaderDesktop.vue'

export default {
  name: 'EDataTableHeader',
  extends: VDataTableHeader,
  render(h, { props, data, slots }) {
    dedupeModelListeners(data)
    const children = rebuildSlots(slots(), h)
    data = mergeData(data, {
      props,
    })
    return h(EDataTableHeaderDesktop, data, children)
  },
}
</script>
